import { SplitButton } from "@features/results/Result/SplitButton"
import DashboardIcon from "@mui/icons-material/Dashboard"
import { useTheme } from "@mui/material"

type ShowDashboardButtonProps = {
  onClick: () => void
}

const ShowDashboardButton = (props: ShowDashboardButtonProps) => {
  const theme = useTheme()

  return (
    <SplitButton
      title={
        <>
          Show dashboard
          <DashboardIcon />
        </>
      }
      sx={{
        button: {
          background: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          "&:hover": {
            backgroundColor: theme.palette.error.dark,
          },
        },
      }}
      instruction="Display the major results from this model visually"
      properties={{ onClick: props.onClick }}
    />
  )
}

export default ShowDashboardButton
